<div>{{ candidate.patientFullName }}</div>
<div class="small"><strong>DOB:</strong> {{ candidate.patientDob | date: 'MM/dd/yyyy' }}</div>
